import loadModuleOnElement from "../utils/loadModuleOnElement";

const loader = () => import("./subscriptionForm");

export default function subscriptionFormLoader(context) {
    loadModuleOnElement(".get-alerts", loader, context);
    return context;
}
